<div class="table-container">
  <form [formGroup]="dropdownDataForm">
    <ul class="files" *ngIf="columns && columns.length">
      <li class="header">
        <div *ngFor="let column of columns">
          <span
            *ngIf="
              !dataSource || column.isDropdown || column.isMultiselectDropdown
            "
          >
            {{ column.label }}
          </span>
          <span
            *ngIf="
              !column.isFilterEnabled &&
              !!dataSource &&
              !column.isDropdown &&
              !column.isMultiselectDropdown
            "
            (click)="sortTableBy(column)"
            class="sort-header"
          >
            {{ column.label }}
            <ng-container>
              <i
                [ngClass]="
                  column.isOrderByAscendant
                    ? sortDescIconClass
                    : sortAscIconClass
                "
              ></i>
            </ng-container>
          </span>
          <span
            class="input-filter-container"
            *ngIf="
              column.isFilterEnabled &&
              !!dataSource &&
              !column.isDropdown &&
              !column.isMultiselectDropdown &&
              !column.isDate
            "
            ><input
              (keyup)="setColumnFilter($event, column)"
              type="text"
              [title]="'Filtrar por ' + column.label"
              placeholder="Filtrar"
          /></span>
          <div
            class="date-menu-container"
            *ngIf="column.isDate && column.isDateMenuOpened"
          >
            <ul>
              <li>
                <span class="label">Fecha desde</span>

                <div class="input input-calendar">
                  <input
                    type="text"
                    (click)="dateFromDatePicker.open()"
                    placeholder="Fecha desde"
                    autocomplete="off"
                    [matDatepicker]="dateFromDatePicker"
                    #dateFromInput
                    formControlName="dateFrom"
                  />
                  <span
                    class="fas fa-calendar-alt"
                    (click)="dateFromDatePicker.open()"
                  ></span>
                </div>

                <mat-datepicker #dateFromDatePicker></mat-datepicker>
              </li>
              <li>
                <span class="label">Fecha hasta</span>

                <div class="input input-calendar">
                  <input
                    type="text"
                    (click)="dateToDatePicker.open()"
                    placeholder="Fecha hasta"
                    autocomplete="off"
                    [matDatepicker]="dateToDatePicker"
                    #fechaDesdeInput
                    formControlName="dateTo"
                  />
                  <span
                    class="fas fa-calendar-alt"
                    (click)="dateToDatePicker.open()"
                  ></span>
                </div>

                <mat-datepicker #dateToDatePicker></mat-datepicker>
              </li>
            </ul>
          </div>
          <span
            class="filter"
            (click)="setFilterEnabledStatus(column)"
            *ngIf="
              column.allowFilter &&
              !!dataSource &&
              !column.isDropdown &&
              !column.isMultiselectDropdown
            "
          >
            <i
              [class.date-filter-button]="column.isDate"
              [ngClass]="
                (column.isFilterEnabled && !column.isDate) ||
                (column.isDateMenuOpened && column.isDate)
                  ? filterClearIconClass
                  : filterSearchIconClass
              "
            ></i>
          </span>
        </div>
        <div>Acción</div>
      </li>
      <li *ngFor="let rowData of filteredDataSource; let i = index">
        <ng-container *ngFor="let column of columns">
          <div
            *ngIf="
              !column.isDropdown &&
              !column.isMultiselectDropdown &&
              column.isEditable &&
              !!rowData.isEditable
            "
          >
            <div
              class="input-container"
              [class.error]="
                dropdownDataForm.get('input_' + column.name + '_' + i).dirty &&
                dropdownDataForm.get('input_' + column.name + '_' + i).invalid
              "
            >
              <div class="input">
                <input
                  [formControl]="
                    dropdownDataForm.controls['input_' + column.name + '_' + i]
                  "
                  type="text"
                  [value]="rowData[column.name]"
                  (change)="editInputValue(column, rowData, $event)"
                />
              </div>
            </div>
          </div>
          <div
            *ngIf="
              !column.isDropdown &&
              !column.isMultiselectDropdown &&
              (!column.isEditable || !rowData.isEditable)
            "
            [title]="
              column.isDate
                ? (rowData[column.name] | date: 'dd/MM/yyyy')
                : rowData[column.name]
            "
          >
            {{
              column.isDate
                ? (rowData[column.name] | date: 'dd/MM/yyyy')
                : rowData[column.name]
            }}
          </div>
          <div *ngIf="column.isDropdown">
            <app-custom-dropdown
              [formControl]="dropdownDataForm.controls[column.name + '_' + i]"
              [options]="column.options"
              [searchable]="false"
            >
            </app-custom-dropdown>
          </div>
          <div *ngIf="column.isMultiselectDropdown">
            <ng-multiselect-dropdown
              [formControl]="dropdownDataForm.controls[column.name + '_' + i]"
              [placeholder]="
                column.multiselectDropdownsettings.searchPlaceholderText
              "
              [settings]="column.multiselectDropdownsettings"
              [data]="column.options"
              (onSelect)="onSelect($event, i)"
              (onDeSelect)="onDeSelect($event, i)"
              (onSelectAll)="onSelectAll($event, i)"
              (onDeSelectAll)="onDeSelectAll($event, i)"
            >
            </ng-multiselect-dropdown>
          </div>
        </ng-container>

        <div class="action-container">
          <i
            [class.disabled]="dropdownDataForm.invalid"
            *ngIf="hasEditAction"
            (click)="editActionEmiterCallback(i, rowData)"
            [ngClass]="editTable(rowData) ? editActiveIconClass : editIconClass"
          ></i>
          <i
            *ngIf="hasDeleteAction"
            (click)="deleteActionEmiterCallback(i, rowData)"
            [ngClass]="deleteIconClass"
          ></i>
          <i
            *ngIf="hasViewAction"
            (click)="viewActionEmiterCallback(i, rowData)"
            [ngClass]="viewIconClass"
          ></i>
        </div>
      </li>
      <li
        class="not-data"
        *ngIf="!filteredDataSource || !filteredDataSource.length"
      >
        <div>No hay datos disponibles</div>
      </li>
    </ul>
  </form>
</div>
